import React from 'react'
import { ListDatosGeneralesForm } from './ListDatosGeneralesForm'

export const DatosGenerales = () => {
    return (
        <div className='grid xl:grid-cols-2 gap-2'>
            <ListDatosGeneralesForm />
        </div>
    )
}